import React from "react";
import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import SocialBookUpdate from "../social_book_update";
import ReadStatusHeader from "./read_status_header";
import PreviewBook from "../../preview_book/preview_book";

export default GrComponentFactory.createClass({
  displayName: "ReadStatusNewsfeedItem",

  propTypes: {
    resource:  React.PropTypes.shape({
      headerText: React.PropTypes.string.isRequired,
      readText: React.PropTypes.string,
      book: GrPropTypes.book().isRequired,
    }).isRequired,
  },

  buildAdditionalFooterLinks() {
    return [<PreviewBook book={this.props.resource.book}/>];
  },

  renderReadText() {
    return (
      this.props.resource.readText ?
      <div className="gr-newsfeedItem__readCountText">
        {this.props.resource.readText}
      </div>
        : null
    );
  },

  render() {
    const resource = this.props.resource;
    return <SocialBookUpdate
      header={<ReadStatusHeader headerText={resource.headerText}/>}
      book={resource.book}
      updateDetails={this.renderReadText()}
      additionalFooterLinks={this.buildAdditionalFooterLinks()}
      {...this.props}
      />;
  },
});
